function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0E3132",
  fillRule: "evenodd",
  d: "M8 15.552l.438-.383C12.126 11.949 14 9.138 14 6.667c0-3.5-2.731-6-6-6s-6 2.5-6 6c0 2.47 1.874 5.282 5.562 8.502l.438.383zm0-1.777c-3.129-2.82-4.667-5.209-4.667-7.109C3.333 3.932 5.443 2 8 2s4.667 1.93 4.667 4.667c0 1.899-1.538 4.289-4.667 7.108zM8 3.333c1.84 0 3.333 1.493 3.333 3.333C11.333 8.508 9.841 10 8 10c-1.841 0-3.333-1.493-3.333-3.333 0-1.841 1.492-3.334 3.333-3.334zM6 6.666c0-1.104.895-2 2-2s2 .896 2 2c0 1.105-.895 2-2 2s-2-.895-2-2z",
  clipRule: "evenodd"
});

var SvgPinEmpty = function SvgPinEmpty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPinEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PinEmpty.bf847acf.svg";
export { ForwardRef as ReactComponent };